export enum Feature {
  Analytics = 'analytics',
  CheckIn = 'checkin',
  CheckOut = 'checkout',
  eSignature = 'eSignature',
  OnBoardDocuments = 'onBoardDocuments',
  Safety = 'safety',
  Medical = 'medical',
  RateModal = 'rateModal',
  CrewPhoto = 'crewPhoto',
  CrewPhotoUpdate = 'crewPhotoUpdate',
  DocManagerFinance = 'docManagerFinance',
  AdminSummary = 'adminSummary',
  DocManagerIdSearch = 'docManagerSearchById',
  CrewCheckinInfoReport = 'crewCheckinInfoReport',
  PolicyAcknowledgementReport = 'policyAcknowledgementReport',
  LateSignOnReport = 'lateSignOnReport',
  HealthCheckReport = 'healthCheckReport',
  MissingSharepointSignonsReport = 'missingSharepointSignonsReport',
  MedicalCertificates = 'medicalCertificates',
  CovidVaxReport = 'covidVaxReport',
  LastOnboard = 'lastOnboard',
}
